<template>
  <div ref="turning_left"></div>
</template>

<script>
import TurningLeft from "!!raw-loader!../../assets/ricoh_assets/icons/BTN006n_turning_left.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.turning_left.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = TurningLeft

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>